// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const HandshakeIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const stroke = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M11 17L13 19C13.197 19.197 13.4308 19.3532 13.6882 19.4598C13.9456 19.5665 14.2214 19.6213 14.5 19.6213C14.7786 19.6213 15.0544 19.5665 15.3118 19.4598C15.5692 19.3532 15.803 19.197 16 19C16.197 18.803 16.3532 18.5692 16.4598 18.3118C16.5665 18.0544 16.6213 17.7786 16.6213 17.5C16.6213 17.2214 16.5665 16.9456 16.4598 16.6882C16.3532 16.4308 16.197 16.197 16 16"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 13.9995L16.5 16.4995C16.8978 16.8974 17.4374 17.1208 18 17.1208C18.5626 17.1208 19.1022 16.8974 19.5 16.4995C19.8978 16.1017 20.1213 15.5621 20.1213 14.9995C20.1213 14.4369 19.8978 13.8974 19.5 13.4995L15.62 9.61953C15.0575 9.05773 14.295 8.74217 13.5 8.74217C12.705 8.74217 11.9425 9.05773 11.38 9.61953L10.5 10.4995C10.1022 10.8974 9.56259 11.1208 8.99998 11.1208C8.43737 11.1208 7.89781 10.8974 7.49998 10.4995C7.10216 10.1017 6.87866 9.56214 6.87866 8.99953C6.87866 8.43692 7.10216 7.89735 7.49998 7.49953L10.31 4.68953C11.2222 3.77967 12.4119 3.20008 13.6906 3.0425C14.9694 2.88492 16.2641 3.15836 17.37 3.81953L17.84 4.09953C18.2658 4.35651 18.772 4.44564 19.26 4.34953L21 3.99953"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 3L22 14H20M3 3L2 14L8.5 20.5C8.89782 20.8978 9.43739 21.1213 10 21.1213C10.5626 21.1213 11.1022 20.8978 11.5 20.5C11.8978 20.1022 12.1213 19.5626 12.1213 19C12.1213 18.4374 11.8978 17.8978 11.5 17.5M3 4H11"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { HandshakeIcon };
